// eslint-disable-next-line import/no-extraneous-dependencies
import { pairs as Pairs } from 'd3-array'
import * as THREE from 'three'

import { fenceMap } from 'bam-node-evp/src/3d/Field/Fence/Lidar/FencesLidar'

const toSegments = (points) => {
    const segments = []
    let segment = []
    let z = null

    points.forEach((p) => {
        if (p.z === z) {
            segment.push(p)
        } else {
            if (segment.length > 0) {
                segments.push(segment)
            }
            segment = [p]
            z = p.z
        }
    })
    if (segment.length > 0) {
        segments.push(segment)
    }

    return segments
}

const toCappedSegments = (segments) => {
    const copy = [...segments]

    const pairs = Pairs(copy)

    pairs.forEach((pair) => {
        const segment0 = pair[0]
        const segment1 = pair[1]
        const p = segment0[segment0.length - 1]
        const q = segment1[0]
        const x = 0.5 * (p.x + q.x)
        const y = 0.5 * (p.y + q.y)
        segment0.push({
            x,
            y,
            z: p.z,
        })
        segment1.unshift({
            x,
            y,
            z: q.z,
        })
    })

    return copy
}

export const toFenceGeometry = ({ venueId, squaredSegmentJoins = true }) => {
    // If venue doesn't exist default to KC
    const points = fenceMap[venueId] || fenceMap[7]

    const distance = {
        lf: points.find((d) => d.angle === -45).distance,
        rf: points.find((d) => d.angle === 45).distance,
    }

    const vertices = []
    const normals = []
    const indices = []
    const colors = []

    const geometry = new THREE.BufferGeometry()

    if (squaredSegmentJoins) {
        const segments = toSegments(points)
        const cappedSegments = toCappedSegments(segments)
        cappedSegments.forEach((segment) => {
            segment.forEach(({ x, y, z }, i) => {
                vertices.push(x, y, z, x, y, 0)
                // If this doesn't work, it could be because this is completely arbitrary
                normals.push(0, 1, 0, 0, 1, 0)
                colors.push(0, 1, 0, 0, 1, 0)

                if (i > 0) {
                    const startIdx = vertices.length / 3 - 2
                    // Two triangles per segment
                    indices.push(startIdx, startIdx + 1, startIdx - 2)
                    indices.push(startIdx + 1, startIdx - 1, startIdx - 2)
                }
            })
        })
    } else {
        points.forEach(({ x, y, z }, i) => {
            vertices.push(x, y, z, x, y, 0)
            // If this doesn't work, it could be because this is completely arbitrary
            normals.push(0, 1, 0, 0, 1, 0)
            colors.push(0, 1, 0, 0, 1, 0)

            if (i > 0) {
                const startIdx = i * 2
                // Two triangles per segment
                indices.push(startIdx, startIdx + 1, startIdx - 2)
                indices.push(startIdx + 1, startIdx - 1, startIdx - 2)
            }
        })
    }

    geometry.setIndex(indices)
    geometry.setAttribute(
        'position',
        new THREE.Float32BufferAttribute(vertices, 3)
    )
    geometry.setAttribute(
        'normal',
        new THREE.Float32BufferAttribute(normals, 3)
    )
    // geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3))

    // geometry.computeFaceNormals()
    // geometry.computeFlatVertexNormals()
    // geometry.computeBoundingBox()
    // geometry.computeBoundingSphere()

    return {
        geometry,
        distance,
    }
}

export const toFence = ({
    venueId,
    color = 0x77c6bf,
    squaredSegmentJoins = true,
    wireframe = false,
}) => {
    const { geometry, distance } = toFenceGeometry({
        venueId,
        squaredSegmentJoins,
    })
    const material = new THREE.MeshBasicMaterial({
        color,
        // shininess: 1,
        // specular: '#ffffff',
        wireframe,
        flatShading: false,
        wireframeLinewidth: 0.4,
        transparent: true,
        side: THREE.DoubleSide,
        opacity: 1,
    })

    const mesh = new THREE.Mesh(geometry, material)
    //    mesh.position.y = 8;
    return { fenceMesh: mesh, distance }
}

export const toAllFencesGroup = () => {
    const g = new THREE.Group()

    return g
}
